import React, { useEffect, useRef, useState } from "react";
import { useSmoothScrollIndex } from "@/hooks/tactsuit/use-smooth-scroll-index";
import { useSmoothAnimationFrame } from "@/hooks/tactsuit/useSmoothAnimationFrame";
import { drawImageOnCanvas } from "@/utils/draw-on-canvas";
import { useCanvasReSize } from "@/hooks/tactsuit/use-canvas-re-size";

interface TactsuitInteractionScrollCanvasProps {
  images: HTMLImageElement[];
  imagesRange: number;
}
export const TactsuitInteractionScrollCanvas = ({
  images,
  imagesRange,
}: TactsuitInteractionScrollCanvasProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  // 스크롤시 부드러운 인덱스 변환
  const smoothIndex = useSmoothScrollIndex({ canvasRef, range: imagesRange });

  // 캔버스 크기를 설정 mobile / desktop
  const canvasSize = useCanvasReSize({
    canvasRef,
    defaultSize: { width: 708, height: 800 },
  });

  //애니메이션 프레임 처리
  useSmoothAnimationFrame({
    smoothIndex,
    images,
    drawImageCb: (index) => {
      if (canvasRef.current) {
        drawImageOnCanvas(canvasRef, images[index], canvasSize);
      }
    },
  });

  // 초기 렌더링 시 첫 번째 이미지 draw
  useEffect(() => {
    if (canvasRef.current) {
      drawImageOnCanvas(canvasRef, images[0], canvasSize);
    }
  }, [images]);

  return (
    <div className="flex h-[318px] w-full items-center justify-center tablet:h-[800px]">
      <canvas ref={canvasRef} />
    </div>
  );
};
